import { Controller } from 'stimulus'

export default class extends Controller {

  connect() {
    if (this.dialogCollectionController.dialog(this.element.dataset.key))  {
      this.dialogCollectionController.dialog(this.element.dataset.key).close(new Event('click'))
    }
  }


  get dialogCollectionController() {
    return this.application.getControllerForElementAndIdentifier(document.body, 'dialog-collection')
  }
}
